const indexItems = [
  { label: '科幻电影合集', count: 2840, icon: 'ri-rocket-line', color: 'bg-primary-100 text-primary-700' },
  { label: '悬疑推理片单', count: 1920, icon: 'ri-search-eye-line', color: 'bg-accent-100 text-accent-700' },
  { label: '奥斯卡获奖影片', count: 1560, icon: 'ri-award-line', color: 'bg-accent-100 text-accent-700' },
  { label: '韩国电影精选', count: 2350, icon: 'ri-flag-line', color: 'bg-secondary-100 text-secondary-700' },
  { label: '动画电影大全', count: 1780, icon: 'ri-emotion-line', color: 'bg-primary-100 text-primary-700' },
  { label: '华语电影天地', count: 3200, icon: 'ri-china-railway-line', color: 'bg-secondary-100 text-secondary-700' },
  { label: '高分纪录片', count: 960, icon: 'ri-camera-lens-line', color: 'bg-primary-100 text-primary-700' },
  { label: '日剧精选合集', count: 1890, icon: 'ri-sun-line', color: 'bg-accent-100 text-accent-700' },
];

export default function IndexSection() {
  return (
    <section id="index" className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading text-center">
          专题索引
        </h2>
        <p className="mt-2 text-sm text-foreground-600 text-center">
          按分类探索片库，找到你感兴趣的影片类型
        </p>
        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {indexItems.map((item, i) => (
            <div
              key={i}
              className="flex items-center gap-4 p-5 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200/60 transition-colors cursor-pointer group"
            >
              <div className={`w-11 h-11 rounded-lg flex items-center justify-center flex-shrink-0 ${item.color}`}>
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <div className="min-w-0">
                <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors truncate">
                  {item.label}
                </h3>
                <p className="text-xs text-foreground-500 mt-0.5">
                  {item.count.toLocaleString()} 部影片
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}